<template>
  <section class="min-h-screen flex items-stretch text-white bg-[#F7F7F7]">
    <!-- Side Menu -->
    <div class="hidden md:flex flex-col justify-between bg-[#090446] text-white w-1/6 p-4">
      <!-- Top Menu -->
      <div class="sticky top-0 bg-[#090446] p-4 z-20">
        <div>
          <p class="text-lg font-semibold">Total Progress: {{ progressDetail.totalAnswers1+progressDetail.totalAnswers2+progressDetail.totalAnswers3 }}/{{ progressDetail.totalQuestions1+progressDetail.totalQuestions2+progressDetail.totalQuestions3 }}</p>
          <p class="text-lg font-semibold">Part - 1 : {{ progressDetail.totalAnswers1 }}/{{ progressDetail.totalQuestions1 }}</p>
          <p class="text-lg font-semibold">Part - 2: {{ progressDetail.totalAnswers2 }}/{{ progressDetail.totalQuestions2 }}</p>
          <p class="text-lg font-semibold">Part - 3: {{ progressDetail.totalAnswers3 }}/{{ progressDetail.totalQuestions3 }}</p>
          <div class="w-full bg-gray-200 rounded-full h-2.5 mt-2">
            <div class="bg-[#ab064e] h-2.5 rounded-full" :style="{ width: ((progressDetail.totalAnswers1+progressDetail.totalAnswers2+progressDetail.totalAnswers3) / (progressDetail.totalQuestions1+progressDetail.totalQuestions2+progressDetail.totalQuestions3)) * 100 + '%' }"></div>
          </div>
        </div>
      </div>

      <!-- Bottom Menu -->
      <div class="mt-auto">
        <router-link to="/privacy-policy" class="text-white hover:text-[#ab064e]">
          Privacy Policy
        </router-link>
      </div>
    </div>

    <!-- Main Content -->
    <div class="flex-1 flex flex-col items-center py-6 md:px-16 px-4 z-0">
      <!-- Instructions Card -->
      <div id="instructions-card" class="bg-white text-black p-6 rounded-lg shadow-lg mb-6 w-full lg:w-3/4">
        <div class="flex items-center justify-center mb-4">
          <a href="#" class="flex items-center">
            <img src="../assets/images/logo.png" class="h-24" alt="Logo" />
          </a>
        </div>
        <h2 class="text-2xl font-bold mb-4 text-center text-[#090446]">Survey Instructions</h2>
        <p class="text-lg">This full assessment will take about 30 minutes to complete...</p>
        <p class="text-lg mt-4">Directions: The following statements concern your perception...</p>
        <ul class="text-lg mt-4">
          <li>1. Strongly disagree</li>
          <li>2. Disagree</li>
          <li>3. Neither disagree nor agree</li>
          <li>4. Agree</li>
          <li>5. Strongly agree</li>
        </ul>
        <p class="text-lg mt-4">There are no "right" or "wrong" answers, so select the number...</p>
      </div>

      <!-- Questions Card -->
      <div id="questions-card" class="bg-white text-black p-6 rounded-lg shadow-lg w-full lg:w-3/4">
        <!-- Tab Navigation -->
        <div class="flex mb-6 border-b">
          <button 
            v-for="tab in 3" 
            :key="tab"
            @click="handleTabClick(tab)"
            class="px-6 py-2 mr-2"
            :class="{
              'border-b-2 border-[#0A0446] text-[#0A0446] font-bold': currentTab === tab,
              'text-gray-400 cursor-not-allowed': !isTabEnabled(tab),
              'cursor-pointer': isTabEnabled(tab)
            }"
            :disabled="!isTabEnabled(tab)"
          >
            Section {{ tab }}
          </button>
        </div>

        <!-- Questions Section -->
        <div class="overflow-x-auto">
          <div v-if="questions.length > 0">
            <h2 class="text-2xl font-bold mb-4 text-left text-[#090446] bg-white z-10 p-6">I am someone who ...</h2>
            <table class="min-w-full border-collapse">
              <thead>
                <tr>
                  <th class="border-b p-4 text-left w-2/5">Question</th>
                  <th class="border-b p-4 text-center w-1/12">Strongly disagree</th>
                  <th class="border-b p-4 text-center w-1/12">Disagree</th>
                  <th class="border-b p-4 text-center w-1/12">Neither disagree nor agree</th>
                  <th class="border-b p-4 text-center w-1/12">Agree</th>
                  <th class="border-b p-4 text-center w-1/12">Strongly agree</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(question, index) in currentQuestions" :key="question.question_id" class="border-t">
                  <!-- Question Text -->
                  <td class="p-4 w-2/5">{{ getQuestionNumber(index) }}. {{ question.question }}</td>

                  <!-- Answer Radio Buttons -->
                  <td v-for="num in 5" :key="num" class="p-4 text-center w-1/12">
                    <label class="flex justify-center items-center cursor-pointer w-full h-full">
                      <input
                        type="radio"
                        :name="'question_' + question.question_id"
                        :value="num"
                        @change="handleAnswerChange(question.question_id, num)"
                        :checked="selectedAnswers[question.question_id] === num"
                        class="hidden"
                      />
                      <span
                        class="flex justify-center items-center w-12 h-12 border border-gray-300 rounded-md text-lg font-semibold"
                        :class="{'bg-[#0A0446] text-white': selectedAnswers[question.question_id] === num, 'hover:bg-gray-200': selectedAnswers[question.question_id] !== num}"
                      >
                        {{ num }}
                      </span>
                    </label>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <!-- Navigation Buttons -->
        <div class="flex justify-between mt-8">
          <button 
            v-if="currentTab > 1"
            class="px-16 py-3 bg-[#0A0446] text-white rounded-lg hover:bg-[#0A0446] transition-all duration-300"
            @click="currentTab--"
          >
            Previous
          </button>
          <button 
            class="relative inline-flex items-center justify-center px-16 py-3 bg-[#0A0446] text-white rounded-lg hover:bg-[#0A0446] transition-all duration-300 h-10"
            @click="handleNavigation"
          >
            <svg v-if="isLoading" class="animate-spin h-5 w-5 text-white absolute" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
              <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"></path>
            </svg>
            <span v-else>{{ currentTab === 3 ? 'Next Part' : 'Next' }}</span>
          </button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Swal from 'sweetalert2'
import Api from '../router/api'
import AppMixin from '../mixins/AppMixin'

export default {
  name: 'NonEmployeeSurveyOne',
  data() {
    return {
      url: '',
      questions: [],
      selectedAnswers: {},
      progressDetail: {
        totalQuestions1: 0,
        totalQuestions2: 0,
        totalQuestions3: 0,
        totalAnswers1: 0,
        totalAnswers2: 0,
        totalAnswers3: 0,
      },
      isLoading: 0,
      currentTab: 1,
      questionsPerTab: 17 // 52/3 ≈ 17 questions per tab (last tab will have 18)
    }
  },
  mounted() {
    let urlToken = this.$route.fullPath.split('/')[2]
    this.url = urlToken
    this.getProgressBarDetail(this.url);
    this.getQuestions(this.url)
  },
  computed: {
    progress() {
      return (Object.keys(this.selectedAnswers).length / this.questions.length) * 100;
    },
    currentQuestions() {
      const start = (this.currentTab - 1) * this.questionsPerTab;
      const end = this.currentTab === 3 ? this.questions.length : start + this.questionsPerTab;
      return this.questions.slice(start, end);
    }
  },
  methods: {
    getQuestions(url) {
      Api.getSectionOneQuestions(url).then(response => {
        this.questions = response.data.res;
        this.questions.forEach(question => {
          this.$set(this.selectedAnswers, question.question_id, question.response);
        });
      });
    },
    getProgressBarDetail(url) {
      Api.getProgressBarDetail(url).then(response => {
        this.progressDetail.totalQuestions1 = response.data.res.totalQuestions1;
        this.progressDetail.totalQuestions2 = response.data.res.totalQuestions2;
        this.progressDetail.totalQuestions3 = response.data.res.totalQuestions3;
        this.progressDetail.totalAnswers1 = response.data.res.totalAnswers1;
        this.progressDetail.totalAnswers2 = response.data.res.totalAnswers2;
        this.progressDetail.totalAnswers3 = response.data.res.totalAnswers3;
      });
    },
    handleAnswerChange(questionId, answer) {
      this.$set(this.selectedAnswers, questionId, answer);
      Api.saveQuestionResponse({ question_id: questionId, response: answer, token: this.url })
      this.getProgressBarDetail(this.url);
    },
    getQuestionNumber(index) {
      return index + 1 + ((this.currentTab - 1) * this.questionsPerTab);
    },
    handleNavigation() {
      // Check if all questions in current section are answered
      const start = (this.currentTab - 1) * this.questionsPerTab;
      const end = this.currentTab === 3 ? this.questions.length : start + this.questionsPerTab;
      const currentQuestions = this.questions.slice(start, end);
      
      const allAnswered = currentQuestions.every(q => this.selectedAnswers[q.question_id]);
      
      if (!allAnswered) {
        this.$swal({
          icon: "warning",
          title: "Warning",
          text: "Please answer all questions in this section before proceeding.",
          showConfirmButton: true,
          confirmButtonColor: '#0A0446'
        });
        return;
      }

      if (this.currentTab < 3) {
        this.currentTab++;
      } else {
        this.continueToNextPage();
      }
    },
    continueToNextPage() {
      this.isLoading = 1;
      Api.submitSectionOne(this.url).then(response => {
        if(response.data.res < 52){
          this.isLoading = 0;
          this.$swal({
            icon: "warning",
            title: "Warning",
            text: "Please answer all the questions.",
            showConfirmButton: true,
            confirmButtonColor: '#0A0446'
          })
        } else {
          this.$router.push(`/survey-two/${this.url}`);
        }
      });
    },
    isTabEnabled(tab) {
    if (tab === 1) return true;
    
    // Check if all questions in previous sections are answered
    const previousSections = Array.from({ length: tab - 1 }, (_, i) => i + 1);
    return previousSections.every(section => this.isSectionComplete(section));
  },
  isSectionComplete(section) {
    const start = (section - 1) * this.questionsPerTab;
    const end = section === 3 ? this.questions.length : start + this.questionsPerTab;
    const sectionQuestions = this.questions.slice(start, end);
    
    return sectionQuestions.every(q => this.selectedAnswers[q.question_id]);
  },

  handleTabClick(tab) {
    if (this.isTabEnabled(tab)) {
      this.currentTab = tab;
    } else {
      this.$swal({
        icon: "warning",
        title: "Section Locked",
        text: "Please complete all questions in the previous sections first.",
        showConfirmButton: true,
        confirmButtonColor: '#0A0446'
      });
    }
  }
  }
}
</script>

<style scoped>
.strongly-text {
  align-items: center;
  justify-content: center;
  display: flex;
}
</style>


// WEBPACK FOOTER //
// src/components/NonEmployeeSurveyOne.vue